import en_US from './en-US';
import fr_FR from './fr-FR';

export default {
  'en-US': en_US,
  'fr-FR': fr_FR,
};
